import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Label = styled.label`
  color: rgb(107, 119, 140);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33333;
  padding: 20px 0px 4px;
  text-transform: capitalize;
`;

export const Footer = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  margin-top: auto;
  padding-top: 30px;

  hr {
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
  }
`;

export const Day = styled.div<{ selected?: boolean }>`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: ${props => (props.selected ? '#ffffff' : '#707071')};
  border: 1px solid ${props => (props.selected ? props.theme.colors.primary : '#707071')};
  background-color: ${props => (props.selected ? props.theme.colors.primary : 'white')};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 44px;
  cursor: pointer;

  ${props => props.selected ? `
    &:hover {
      opacity: 0.8;
    }
  ` : `
    &:hover {
      color: ${props.theme.colors.primary};
      border: 1px solid ${props.theme.colors.primary};
    }
  `}
`
